var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "transparent",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 0.5,
    y: 0.5,
    stroke: "#8C8E92",
    rx: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8E92",
    fillRule: "evenodd",
    d: "M8.114 11.009a.968.968 0 0 0-.708.29l-.003.003a1.01 1.01 0 0 0-.273.718c0 .273.09.511.273.705l.003.003c.193.192.432.29.708.29.29 0 .533-.095.712-.295a.993.993 0 0 0 .272-.703c0-.28-.09-.522-.272-.717-.179-.2-.422-.294-.712-.294ZM5.01 4.572l-.084.1L6 5.799l.104-.137c.285-.374.583-.652.893-.842L7 4.817c.3-.192.67-.292 1.114-.292.262 0 .49.055.685.16.197.108.346.25.45.426l.003.004c.112.175.17.38.17.621 0 .196-.045.367-.132.516l-.003.006c-.08.153-.209.308-.39.464l-.003.003a5.9 5.9 0 0 1-.67.508l-.001.001a2.268 2.268 0 0 0-.703.734c-.165.29-.222.637-.183 1.034l.095.997h1.356l.049-.822a2.61 2.61 0 0 1 .077-.464.639.639 0 0 1 .168-.28c.089-.088.215-.182.382-.278l.002-.002c.31-.188.585-.4.823-.638.25-.24.444-.512.58-.813.136-.303.205-.625.205-.966 0-.554-.134-1.04-.408-1.452a2.603 2.603 0 0 0-1.058-.956 3.045 3.045 0 0 0-1.453-.346c-.661 0-1.254.142-1.772.43-.503.276-.96.663-1.373 1.16Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/questionMark.c051a4edc626f12eed29ab2a3c8b5f0f.svg";
export { ForwardRef as ReactComponent };